"use client";
import { FlagProvider } from "@unleash/nextjs";
import { PropsWithChildren } from "react";
import { SWRConfig } from "swr";

export const Providers = ({ children }: PropsWithChildren) => {
  return (
    <SWRConfig
      value={{
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
      }}
    >
      <FlagProvider config={{ disableMetrics: false, refreshInterval: 5 * 60 }}>
        {children}
      </FlagProvider>
    </SWRConfig>
  );
};
